module.exports = __webpack_public_path__ + "static/media/Edusessions Uganda_cover.e25f9828.png";